
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/news",
      function () {
        return require("private-next-pages/[locale]/news/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/news"])
      });
    }
  